import FormButton from "../forms/FormButton";
import FormButtons from "../forms/FormButtons";
import ParentField from "../fields/ParentField";
import Placeholder from "../../Placeholder";
import React, {useState} from 'react';
import {Form, Formik} from "formik";
import {compose} from "redux";
import {duckify, singleDuck} from "../../../utils/duckify";
import {flashMessages, sharedPortalParents} from "../../../ducks";
import {prefixKeys} from "../../../utils/objects";
import {withRouter} from "react-router";


const ParentEditor = ({duckMeta, flash, parent = {}, router, save}) => {
  const [errors, setErrors] = useState({});
  const ready = !duckMeta.parent || duckMeta.parent.ready;
  const error = duckMeta.error;

  const onSubmit = (values, {validateForm}) =>
    save(values.parent).then(() => {
      flash({message: "Parent saved.", type: "success", dismissible: true});
      router.push("/profile");
    }).catch(response => {
      if (response.parent) {
        setErrors(prefixKeys(response.parent.errors, 'parent.'));
        validateForm(); // push errors to formik
      }
    });

  return (
    <React.Fragment>
      <h1>Parent Information</h1>

      {!ready && (<Placeholder.loading/>)}

      {ready && error && (
        <h2 className="error">Parent Not Found</h2>
      )}

      {ready && !error && (
        <Formik
          initialValues={{parent}}
          onSubmit={onSubmit}
          validate={() => errors}>
          {
            ({handleSubmit, validateForm}) => {

              const onSave = () => {
                setErrors({});
                validateForm().then(() => handleSubmit());
              };

              return (
                <Form className="sp-parent-form sp-form">
                  <ParentField entity="parent" required />
                  <FormButtons>
                    <FormButton style="outline-primary" onClick={() => router.push("/profile")}>Cancel</FormButton>
                    <FormButton onClick={onSave}>Save</FormButton>
                  </FormButtons>
                </Form>
              );
            }
          }
        </Formik>
      )}

    </React.Fragment>
  );
};

const mapDispatchToProps = (dispatch) => ({
  flash: (props) => dispatch(flashMessages.actions.show(props)),
  save: (parent) => dispatch(sharedPortalParents.actions.save(parent)),
});

const mapDucksToProps = ({params}) => {
  const {id} = params;
  return id
    ? {parent: singleDuck(sharedPortalParents, id)}
    : {}
};

export default compose(
  withRouter,
  duckify(mapDucksToProps, undefined, mapDispatchToProps)
)(ParentEditor);
